module.exports = __webpack_public_path__ + "img/sb04.765109b4.png";